/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import { useQuery, gql, useApolloClient, useMutation } from '@apollo/client';
import { withTranslation } from 'react-i18next';
import CustomLoader from '../components/Loader/CustomLoader';
// core components
import Header from '../components/Headers/Header';
import { AdminLockOrdersToRiders, getallworker, GetRiderLockOrdersByTimeSlot, getDeliveryDatesForOrders, LockRidersToOrdersByAlgorithm, SwapRiderOrders } from '../apollo';
import DataTable from 'react-data-table-component';
import orderBy from 'lodash/orderBy';
import {
  Container,
  Button,
  Checkbox,
  useTheme,
  Box,
  Snackbar,
  Alert,
  Paper,
  Typography,
  Grid,
  MenuItem,
  TextField,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { customStyles } from '../utils/tableStyleFOrAllOrders';
import useGlobalStyles from '../utils/globalStyles';
import TableHeader from '../components/TableHeader';
import { orderCustomStyles } from '../utils/tableForRiderOutForDeliveryTable';
import { Icon } from '@iconify/react';

// Your existing GraphQL definitions
const GET_RIDERDETAILS = gql`${getallworker}`;
const GET_RIDER_LOCK_ORDERS_BY_TIMESLOT = gql`${GetRiderLockOrdersByTimeSlot}`;
const ADMIN_LOCK_RIDERS_FOR_ORDERS = gql`${AdminLockOrdersToRiders}`;
const SWAP_RIDER_ORDERS = gql`${SwapRiderOrders}`;

export const GET_DELIVERY_DATES_FOR_ORDERS = gql`${
  getDeliveryDatesForOrders }
`;

export const LOCK_RIDERS_TO_ORDERS_BY_ALGORITHM = gql`${LockRidersToOrdersByAlgorithm}`;

const AssignRider = (props) => {
  const { t } = props;
  const theme = useTheme();
  const client = useApolloClient();
  const globalClasses = useGlobalStyles();

  // Alert/Snackbar state
  const [alertMessage, setAlertMessage] = useState('');
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');

  // Rider table state
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedRiders, setSelectedRiders] = useState([]);
  const [selectedRiderIds, setSelectedRiderIds] = useState([]);

  // Order table state
  const [ordertableData, setORderTableData] = useState([]);
  const [orderTotalRows, setOrderTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOrders, setSelectedOrders] = useState([]);
const [selectAllRiders, setSelectAllRiders] = useState(false);
const [selectAllOrders, setSelectAllOrders] = useState(false);
  // Manual Assignment (Admin Lock) specific state
  const [adminLockResults, setAdminLockResults] = useState(null);

  // Auto-assignment specific state
  const [deliveryDates, setDeliveryDates] = useState([]);
  // NEW STATE: For selected date (e.g., "2025-07-14")
  const [selectedDate, setSelectedDate] = useState('');
  // NEW STATE: For selected slotId (e.g., "67e5010741ae9e2348bf9339")
  const [selectedSlotId, setSelectedSlotId] = useState('');
  const [autoAssignmentResults, setAutoAssignmentResults] = useState(null);

  // Filtered slots based on selectedDate
  const filteredTimeSlots = selectedDate
    ? deliveryDates.filter(slot => slot.date === selectedDate)
    : [];

  // ----------------------------------------------------
  // GraphQL Queries & Mutations
  // ----------------------------------------------------

  const { loading: loadingQuery } = useQuery(GET_RIDERDETAILS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data && data.getAllWorkersForLocalStore) {
        const filteredData = data.getAllWorkersForLocalStore.filter(
          worker => worker.workerType === 2 && worker.isActive === true
        );
        setTableData(filteredData);
        setTotalRows(filteredData.length);
      }
    },
    onError: handleQueryError,
  });

  const { loading: loadingOrder, refetch: refetchOrders } = useQuery(GET_RIDER_LOCK_ORDERS_BY_TIMESLOT, {
    // Condition to skip until both date and slotId are selected
    skip: !selectedDate || !selectedSlotId,
    variables: {
      timeSlotId: selectedSlotId, // Use selectedSlotId
      orderDate: selectedDate,    // Use selectedDate
    },
    onCompleted: (data) => {
      const orders = data.getRiderLockOrdersByTimeSlot || [];
      setORderTableData(orders);
      setOrderTotalRows(orders.length);
    },
    onError: handleQueryError,
  });

  // Manual Assignment (Admin Lock) Mutation
  const [swapRiderOrdersMutation, { loading: swapLoading }] = useMutation(SWAP_RIDER_ORDERS, {
    onCompleted: (data) => {
      const result = data && data.swapRiderOrders;
      if (result) {
        setAlertMessage(`${result.message || 'Riders order swap completed successfully.'} Swapped ${result.swappedOrderCount || 0} orders.`);
        setAlertSeverity('success');
        setSelectedRiders([]);
        setSelectedRiderIds([]);
      } else {
        setAlertMessage('Swap rider orders returned no data. Check backend.');
        setAlertSeverity('info');
      }
      setAlertOpen(true);
    },
    onError: (error) => {
      console.error('Swap rider orders error:', error);
      setAlertMessage(`Error swapping rider orders: ${error.message}`);
      setAlertSeverity('error');
      setAlertOpen(true);
    }
  });

  const [adminLockRidersMutation, { loading: adminLockLoading }] = useMutation(ADMIN_LOCK_RIDERS_FOR_ORDERS, {
    onCompleted: (data) => {
      const result = data && data.adminLockOrdersToRiders;

      if (result) {
        const assignedOrdersArray = result.assigned
          ? result.assigned.flatMap(riderAssignment =>
              (riderAssignment.orders || []).map(order => ({
                ...order,
                lockedRiderEmail: riderAssignment.riderEmail || 'N/A'
              }))
            )
          : [];

        const unassignedOrdersArray = result.unassigned && result.unassigned.orders
          ? result.unassigned.orders
          : [];

        localStorage.setItem(
          'adminLockOrderResults',
          JSON.stringify({
            assignedOrders: assignedOrdersArray,
            unassignedOrders: unassignedOrdersArray
          })
        );

        props.history.push('/local_admin/adminlockriderresult');

        setAlertMessage('Orders successfully locked to riders by admin.');
        setAlertSeverity('success');
      } else {
        console.warn('Admin lock returned no data or unexpected structure from backend.');
        setAlertMessage('Admin lock returned no data. Check backend.');
        setAlertSeverity('info');
      }

      setAlertOpen(true);
      refetchOrders();
      setSelectedOrders([]);
      setSelectedRiders([]);
    },
    onError: (error) => {
      console.error('Admin lock error (Frontend):', error);
      setAlertMessage(`Error locking riders manually: ${error.message}`);
      setAlertSeverity('error');
      setAlertOpen(true);
    }
  });


  // Get Delivery Dates (for auto-assignment dropdown)
  const { loading: datesLoading } = useQuery(GET_DELIVERY_DATES_FOR_ORDERS, { // Using a slightly different query name for clarity if needed, or keep GET_DELIVERY_DATES_FOR_ORDERS
    onCompleted: (data) => {
      if (data && data.getDeliveryDatesForOrders && data.getDeliveryDatesForOrders.length > 0) {
        setDeliveryDates(data.getDeliveryDatesForOrders);

        // Optionally, pre-select the first available date and its first slot
        const uniqueDates = [...new Set(data.getDeliveryDatesForOrders.map(slot => slot.date))];
        if (uniqueDates.length > 0) {
          setSelectedDate(uniqueDates[0]);
          const firstSlotForFirstDate = data.getDeliveryDatesForOrders.find(slot => slot.date === uniqueDates[0]);
          if (firstSlotForFirstDate) {
            setSelectedSlotId(firstSlotForFirstDate.slotId);
          }
        }
      }
    },
    onError: (err) => {
      console.error('Error fetching delivery dates:', err);
      setAlertMessage('Error fetching delivery dates. Please try again.');
      setAlertSeverity('error');
      setAlertOpen(true);
    },
  });

  // Auto-assignment Mutation
  const [
    lockRidersByAlgorithm,
    { loading: algorithmLoading },
  ] = useMutation(LOCK_RIDERS_TO_ORDERS_BY_ALGORITHM, {
    onCompleted: (data) => {
      if (data && data.lockRidersToOrdersByAlgorithm) {
        const result = data.lockRidersToOrdersByAlgorithm;

        const assignedOrdersAuto = result.assigned
          ? result.assigned.flatMap(riderAssignment =>
              (riderAssignment.orders || []).map(order => ({
                ...order,
                lockedRiderEmail: riderAssignment.riderEmail || 'N/A'
              }))
            )
          : [];

        const unassignedOrdersAuto = result.unassigned && result.unassigned.orders
          ? result.unassigned.orders
          : [];

        // No longer navigating to a separate page, so keep results in state or use a modal/dialog
        // localStorage.setItem(
        //   'autoAssignRiderResults',
        //   JSON.stringify({
        //     assignedOrders: assignedOrdersAuto,
        //     unassignedOrders: unassignedOrdersAuto
        //   })
        // );

        // props.history.push('/local_admin/autoassignriderresult'); // REMOVE THIS LINE

        setAlertMessage('Orders successfully assigned by algorithm.');
        setAlertSeverity('success');
      } else {
        setAlertMessage('Auto-assignment returned no data. Check backend.');
        setAlertSeverity('info');
      }
      setAlertOpen(true);
      refetchOrders();
      setSelectedOrders([]);
      setSelectedRiders([]);
    },
    onError: (err) => {
      console.error('Error locking riders by algorithm:', err);
      setAlertMessage(`Error automatically assigning riders: ${err.message}`);
      setAlertSeverity('error');
      setAlertOpen(true);
    },
  });
// Add these handler functions inside your component
const handleSelectAllRiders = () => {
  if (!selectAllRiders) {
    const allRiderEmails = tableData.map(rider => rider.email);
    const allRiderIds = tableData.map(rider => rider._id);
    setSelectedRiders(allRiderEmails);
    setSelectedRiderIds(allRiderIds);
  } else {
    setSelectedRiders([]);
    setSelectedRiderIds([]);
  }
  setSelectAllRiders(prev => !prev);
};

const handleSelectAllOrders = () => {
  if (!selectAllOrders) {
    const allOrderIds = ordertableData.map(order => order._id);
    setSelectedOrders(allOrderIds);
  } else {
    setSelectedOrders([]);
  }
  setSelectAllOrders(prev => !prev);
};

// And remember the useEffects to sync the header checkbox with individual selections
useEffect(() => {
    if (tableData.length > 0 && selectedRiders.length === tableData.length) {
        setSelectAllRiders(true);
    } else {
        setSelectAllRiders(false);
    }
}, [selectedRiders.length, tableData.length]);

useEffect(() => {
    // ... (existing order fetching logic)
    if (ordertableData.length > 0 && selectedOrders.length === ordertableData.length) {
      setSelectAllOrders(true);
    } else {
      setSelectAllOrders(false);
    }
}, [selectedDate, selectedSlotId, refetchOrders, selectedOrders.length, ordertableData.length]);
  // ----------------------------------------------------
  // Helper Functions
  // ----------------------------------------------------

  function handleQueryError(error) {
    const isForbiddenError = error.graphQLErrors && error.graphQLErrors.some(err => err.extensions && err.extensions.code === 'FORBIDDEN');
    if (isForbiddenError) {
      localStorage.removeItem('user-native');
      localStorage.removeItem('restaurant_id');
      client.clearStore();
      props.history.push('/auth/login');
    } else {
      setAlertMessage(`GraphQL Error: ${error.message}`);
      setAlertSeverity('error');
      setAlertOpen(true);
    }
  }

  // No longer strictly needed for this specific dropdown logic, but kept for completeness
  function convertToISO(deliveryDateString) {
    if (!deliveryDateString || !isNaN(new Date(deliveryDateString))) {
      return deliveryDateString;
    }
    const cleanedDate = deliveryDateString.replace(/(\d+)(st|nd|rd|th)/, "$1");
    const match = cleanedDate.match(/(\d+)\s*([A-Za-z]+)\s*(\d{4}),\s*(\d{2}:\d{2}\s*(?:am|pm))(?: - \d{2}:\d{2}\s*(?:am|pm))?/i);
    let parsedDate;
    if (match) {
      const day = match[1];
      const monthAbbr = match[2];
      const year = match[3];
      const time = match[4];
      const dateStringForParse = `${monthAbbr} ${day} ${year} ${time}`;
      parsedDate = new Date(dateStringForParse);
    } else {
      parsedDate = new Date(cleanedDate);
    }
    return parsedDate instanceof Date && !isNaN(parsedDate) ? parsedDate.toISOString() : deliveryDateString;
  }

  // ----------------------------------------------------
  // Event Handlers for UI Interactions
  // ----------------------------------------------------

  const handleRiderCheckboxSelection = (rider) => {
    const id = rider && rider._id;
    const email = rider && rider.email;

    setSelectedRiderIds(prev =>
      prev.includes(id) ? prev.filter(selectedId => selectedId !== id) : [...prev, id]
    );

    setSelectedRiders(prev =>
      prev.includes(email) ? prev.filter(selectedEmail => selectedEmail !== email) : [...prev, email]
    );
  };

  const handleSwapRiderOrders = () => {
    if (selectedRiderIds.length !== 2) {
      setAlertMessage('Please select exactly two riders to swap orders between.');
      setAlertSeverity('warning');
      setAlertOpen(true);
      return;
    }

    const [riderAId, riderBId] = selectedRiderIds;
    swapRiderOrdersMutation({
      variables: {
        riderAId,
        riderBId,
      },
    });
  };

  const handleOrderCheckboxSelection = (orderId) => {
    setSelectedOrders(prev =>
      prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]
    );
  };

  const handleAdminLockRidersFromSelection = () => {
    setAutoAssignmentResults(null);
    if (selectedOrders.length === 0 || selectedRiders.length === 0) {
      setAlertMessage('Please select at least one order and one rider from the tables for admin lock.');
      setAlertSeverity('warning');
      setAlertOpen(true);
      return;
    }
    if (selectedOrders.length < selectedRiders.length) {
      setAlertMessage('Cannot assign more riders than selected orders. Please adjust your selection.');
      setAlertSeverity('warning');
      setAlertOpen(true);
      return;
    }

    const payload = {
      assignOrdersInput: {
        orderIds: selectedOrders,
        riders: selectedRiders,
      },
    };

    adminLockRidersMutation({ variables: payload })
      .then((response) => {
        const { adminLockOrdersToRiders } = response.data;
        if (adminLockOrdersToRiders) {
          setAdminLockResults({
            assignedOrders: adminLockOrdersToRiders.assigned && adminLockOrdersToRiders.assigned.orders ? adminLockOrdersToRiders.assigned.orders : [],
            unassignedOrders: adminLockOrdersToRiders.unassigned && adminLockOrdersToRiders.unassigned.orders ? adminLockOrdersToRiders.unassigned.orders : []
          });

          setAlertMessage('Orders successfully locked to riders by admin.');
          setAlertSeverity('success');
        } else {
          setAlertMessage('Admin lock returned no data. Check backend.');
          setAlertSeverity('info');
        }

        setAlertOpen(true);
        refetchOrders();
        setSelectedOrders([]);
        setSelectedRiders([]);
      })
      .catch((error) => {
        console.error("Admin lock error:", error);
        setAlertMessage(`Something went wrong with admin lock: ${error.message}`);
        setAlertSeverity('error');
        setAlertOpen(true);
        setAdminLockResults(null);
      });
  };

  useEffect(() => {
    // Only refetch orders if both a date and a slotId are selected
    if (selectedDate && selectedSlotId) {
      refetchOrders({
        timeSlotId: selectedSlotId,
        orderDate: selectedDate,
      });
    } else {
        // Optionally clear orders if selections are incomplete
        setORderTableData([]);
        setOrderTotalRows(0);
    }
  }, [selectedDate, selectedSlotId, refetchOrders]); // Depend on both new states


  const handleLockRidersByAlgorithmClick = () => {
    setAdminLockResults(null);
    if (!selectedDate || !selectedSlotId) { // Validate both date and slotId
      setAlertMessage('Please select both a delivery date and a time slot for automatic assignment.');
      setAlertSeverity('info');
      setAlertOpen(true);
      return;
    }

    setAutoAssignmentResults(null);
    lockRidersByAlgorithm({
      variables: {
        slotId: selectedSlotId, // Use the separate selectedSlotId state
        date: selectedDate,    // Use the separate selectedDate state
      },
    });
  };

  const handlePerRowChange = (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // ----------------------------------------------------
  // DataTable Column Definitions
  // ----------------------------------------------------

  const columns = [
    { name: 'Name', selector: row => row.name },
    { name: 'Email', selector: row => row.email },
    { name: 'Phone', selector: row => row.phone },
  {
  name: (
    <Box display="flex" alignItems="center" gap={1}>
      <span style={{ color: 'white' }}>Select All</span>
      <Checkbox
        checked={selectAllRiders}
        onChange={handleSelectAllRiders}
        indeterminate={
          selectedRiders.length > 0 &&
          selectedRiders.length < tableData.length
        }
      />
    </Box>
  ),
  cell: (row) => (
    <Checkbox
      checked={selectedRiders.includes(row.email)}
      onChange={() => handleRiderCheckboxSelection(row)}
    />
  ),
  width: '140px',
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
}

  ]

  const orderColumns = [
    { name: 'Order ID', selector: row => row._id, cell: (row) => <>{row._id.slice(-5)}</> },
    {
      name: 'Customer Name',
      selector: row => row.customer && row.customer.name || 'NA',
      style: { cursor: 'pointer', minWidth: "150px" },
    },
    {
      name: 'Customer Phone',
      selector: row => row.customer && row.customer.phone || 'NA',
      style: { cursor: 'pointer', minWidth: "150px" },
    },
    { name: 'Delivery Date', selector: row => row.deliveryDate, cell: (row) => <>{row.deliveryDate}</> },
    {
      name: "Delivery Address",
      sortable: false,
      cell: row => {
        const deliveryAddress = row.deliveryAddress;
        const details = deliveryAddress && deliveryAddress.details ? deliveryAddress.details : "NA";
        const address = deliveryAddress && deliveryAddress.deliveryAddress ? deliveryAddress.deliveryAddress : "NA";
        return <>{`${details}, ${address}`}</>;
      },
      style: { cursor: 'pointer', minWidth: "300px", textAlign: 'left' },
    },
    {
      name: 'Locked Rider',
      selector: row => row.orderState && row.orderState.lockedRiderEmail || 'Not Assigned',
      style: { minWidth: "200px" },
    },
    { name: 'Amount', selector: row => row.orderAmount },
{
  name: (
    <Box display="flex" alignItems="center" gap={1}>
      <span style={{ color: 'white' }}>Select All</span>
      <Checkbox
        checked={selectAllOrders}
        onChange={handleSelectAllOrders}
        indeterminate={
          selectedOrders.length > 0 &&
          selectedOrders.length < ordertableData.length
        }
      />
    </Box>
  ),
  cell: (row) => (
    <Checkbox
      checked={selectedOrders.includes(row._id)}
      onChange={() => handleOrderCheckboxSelection(row._id)}
    />
  ),
  width: '140px',
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
}


  ];

  // ----------------------------------------------------
  // Render
  // ----------------------------------------------------

  return (
    <>
      <Header />
      <Container className={globalClasses.flex} fluid>
        <Snackbar open={alertOpen} autoHideDuration={6000} onClose={() => setAlertOpen(false)}>
          <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity}>
            {alertMessage}
          </Alert>
        </Snackbar>

        {/* Auto-Assignment Section */}
        <Paper elevation={2} sx={{
          p: 1.5,
          mb: 2,
          mt: 2,
          maxWidth: '800px', // adjust as needed
          width: '100%'
        }}>
          <Typography variant="h6" gutterBottom color="black">
            Automatic Rider Assignment
          </Typography>

          <Grid container spacing={2} alignItems="center">
            {/* Separate Dropdown for Date */}
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Select Date"
                value={selectedDate}
                onChange={(e) => {
                  setSelectedDate(e.target.value);
                  setSelectedSlotId(''); // Clear slot when date changes
                }}
                fullWidth
                disabled={datesLoading || deliveryDates.length === 0 || algorithmLoading}
                sx={{
                  '& .MuiInputBase-input': { color: 'black' },
                  '& .MuiInputLabel-root': { color: 'black' },
                  '& .MuiSvgIcon-root': { color: 'black' },
                }}
              >
                {datesLoading ? (
                  <MenuItem disabled sx={{ color: 'black' }}>Loading dates...</MenuItem>
                ) : [...new Set(deliveryDates.map(slot => slot.date))].length > 0 ? (
                  Array.from(new Set(deliveryDates.map(slot => slot.date))).map((date) => (
                    <MenuItem key={date} value={date} sx={{ color: 'black' }}>
                      {date} {/* Display the date string */}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled sx={{ color: 'black' }}>
                    No Dates Available
                  </MenuItem>
                )}
              </TextField>
            </Grid>

            {/* Separate Dropdown for Time Slot */}
            <Grid item xs={12} md={4}>
              <TextField
                select
                label="Select Time Slot"
                value={selectedSlotId}
                onChange={(e) => setSelectedSlotId(e.target.value)}
                fullWidth
                disabled={!selectedDate || datesLoading || filteredTimeSlots.length === 0 || algorithmLoading}
                sx={{
                  '& .MuiInputBase-input': { color: 'black' },
                  '& .MuiInputLabel-root': { color: 'black' },
                  '& .MuiSvgIcon-root': { color: 'black' },
                }}
              >
                {datesLoading ? (
                  <MenuItem disabled sx={{ color: 'black' }}>Loading slots...</MenuItem>
                ) : !selectedDate ? (
                  <MenuItem disabled sx={{ color: 'black' }}>Select a Date First</MenuItem>
                ) : filteredTimeSlots.length > 0 ? (
                  filteredTimeSlots.map((slot) => (
                    <MenuItem key={slot.slotId} value={slot.slotId} sx={{ color: 'black' }}>
                      {slot.deliveryString.split(' : ')[1]} {/* Display only the time part */}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled sx={{ color: 'black' }}>
                    No Slots for this Date
                  </MenuItem>
                )}
              </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleLockRidersByAlgorithmClick}
                disabled={!selectedDate || !selectedSlotId || algorithmLoading} // Disable if date or slot not selected
                startIcon={algorithmLoading ? <CircularProgress size={20} color="inherit" /> : <Icon icon="mdi:robot-happy-outline" />}
                fullWidth
              >
                {algorithmLoading ? 'Assigning Automatically...' : 'Lock Riders (Auto-Assign)'}
              </Button>
            </Grid>
          </Grid>

        </Paper>

        {/* Display Rider and Order Tables */}
        {loadingQuery || loadingOrder ? (
          <CustomLoader />
        ) : (
          <>
            
<DataTable
  customStyles={customStyles}
title={<TableHeader title={t('Rider List')} />}
columns={columns}
  data={tableData || []}
  pagination
  paginationServer
  paginationTotalRows={totalRows}
/>

<br />


<DataTable
  customStyles={orderCustomStyles}
  title={<TableHeader title={t('Order List')} />}
columns={orderColumns}
data={ordertableData || []}
  paginationDefaultPage={currentPage}
  pagination
  paginationServer
  paginationTotalRows={orderTotalRows}
  onChangeRowsPerPage={handlePerRowChange}
  onChangePage={handlePageChange}
/>
            <br />
          </>
        )}
        <Box display="flex" justifyContent="flex-end" sx={{ mb: 1, gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSwapRiderOrders}
            disabled={swapLoading || selectedRiderIds.length !== 2}
            startIcon={swapLoading ? <CircularProgress size={20} color="inherit" /> : <Icon icon="mdi:swap-horizontal" />}
          >
            {swapLoading ? 'Swapping...' : 'Swap Rider Orders'}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAdminLockRidersFromSelection}
            disabled={
              adminLockLoading ||
              selectedOrders.length === 0 ||
              selectedRiders.length === 0 ||
              selectedOrders.length < selectedRiders.length
            }
            startIcon={adminLockLoading ? <CircularProgress size={20} color="inherit" /> : <Icon icon="mdi:lock-outline" />}
          >
            {adminLockLoading ? 'Locking Assignments...' : 'Admin Lock Riders'}
          </Button>
        </Box>

      </Container>
    </>
  );
};

export default withTranslation()(AssignRider);
